<script lang="ts">
	import type { EmblaCarouselType, EmblaEventType } from 'embla-carousel';

	import ThumbnailImage from '$lib/components/ThumbnailImage.svelte';
	import emblaCarouselSvelte, { type EmblaCarouselSvelteType } from 'embla-carousel-svelte';

	const {
		images,
		onclick,
	}: {
		images: string[];
		onclick?: (index: number) => void;
	} = $props();

	let imageIndex = $state(0);

	function onInit(e: CustomEvent<EmblaCarouselSvelteType>) {
		const emblaApi = e.detail as EmblaCarouselType;

		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		emblaApi.on('scroll', (emblaApi: EmblaCarouselType, e: EmblaEventType) => {
			imageIndex = emblaApi.selectedScrollSnap();
		});
	}
</script>

<div class="w-full overflow-hidden" use:emblaCarouselSvelte onemblaInit={onInit}>
	<div class="flex">
		{#each images as image, i (i)}
			<button
				type="button"
				class="aspect-[4/3] shrink-0 grow-0 basis-full cursor-zoom-in bg-neutral-100"
				onclick={() => onclick?.(i)}
			>
				<ThumbnailImage
					src="product/{image}"
					class="h-full w-full object-contain"
					defaultSize={1200}
					loading={i === 0 ? 'eager' : 'lazy'}
					fetchpriority={i === 0 ? 'high' : 'auto'}
					decoding="async"
				/>
			</button>
		{/each}
	</div>
	<div class="flex w-full bg-neutral-100">
		{#each Array.from({ length: images.length }, (_, i) => i) as i (i)}
			<div
				class={[
					'h-1 flex-1 transition-colors duration-300',
					{ 'bg-black': imageIndex === i, 'bg-inherit': imageIndex !== i },
				]}
			></div>
		{/each}
	</div>
</div>
